export default __webpack_public_path__ + "static/media/warn-icon.67c266a3.svg";